import { inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	ResolveFn,
	RouterStateSnapshot
} from '@angular/router';
import { Environment } from '../../../definitions/deployments/environment';
import { EnvironmentsService } from '../services/environments.service';

export const environmentResolver: ResolveFn<Environment> = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
) => {
	const environmentsSvc = inject(EnvironmentsService);
	const environmentId = parseInt(route.paramMap.get('environmentId'));
	if (isNaN(environmentId)) {
		return null;
	}
	return environmentsSvc.find(environmentId);
};
